module.exports = __webpack_public_path__ + "static/media/8.c76908a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/8.svg
// module id = 413
// module chunks = 14